import { createColumnHelper } from '@tanstack/table-core';
import React, { useEffect, useMemo,useState } from 'react';

import APIGateway from '@/api';
import { NativeTable } from '@/components/nativeTable/nativeTable';
import { useNativeTable } from '@/components/nativeTable/useNativeTable';
import { buildColumnClassString } from '@/components/table/table';
import { OutputFormatEnum, TimeFormatter, TimeSourceTypeEnum } from '@/utils/timeFormatter';


type PerformanceData = {
  date: string;
  accuracy: number;
  toxicity: number;
  professionalism: number;
  judgemental: number;
  mlflowUrl: string;
};

const columnHelper = createColumnHelper<PerformanceData>();


export default function PerformanceView() {
  const [ performanceData, setPerformanceData ] = useState<PerformanceData[]>( [] );

  useEffect( ()=>{
    ( async function() {
      const table_rows: PerformanceData[] = [];
      const spans_json = await APIGateway.reports.reportsGet();

      for( const span of spans_json.runs ) {
        const { data, info } = span;

        const date = TimeFormatter( {
          sourceType: TimeSourceTypeEnum.EPOCH_MILLI,
          value: info.start_time.toString(),
          outputFormat: OutputFormatEnum.STRING_SINGLE
        } );
        const accuracy = 1;
        let toxicity = 0;
        let professionalism = 0;
        let judgemental = 0;

        if( !data.metrics ) continue;

        for( const metric of data.metrics ) {
          const { key, value } = metric;

          if( key == 'toxicity/v1/mean' ) {
            toxicity = ( value ) * 100;
          }
          if( key == 'professionalism/v1/mean' ) {
            professionalism = ( value ) * 1;
          }
          if( key == 'judgemental/v1/mean' ) {
            judgemental = ( value ) * 10;
          }
        }

        table_rows.push( {
          date,
          accuracy,
          toxicity,
          professionalism,
          judgemental,
          mlflowUrl: 'http://52.39.121.1:5000/#/experiments/820078897378603603/runs/91328bb7ee3645a68a3b1d22455c384b'
        } );
      }

      setPerformanceData( table_rows );
    } )();
  }, [] );

  const columns = useMemo( () => [
    columnHelper.accessor( 'date', {
      header: 'Run Date',
      size: 200,
      cell: info => info.getValue(),
      meta: {
        classStr: buildColumnClassString( { width: 20 } )
      }
    } ),
    columnHelper.accessor( 'accuracy', {
      header: 'Accuracy Score',
      size: 150,
      cell: info => info.getValue().toFixed( 3 ),
      meta: {
        classStr: buildColumnClassString( { width: 15 } )
      }
    } ),
    columnHelper.accessor( 'toxicity', {
      header: 'Toxicity Score',
      size: 150,
      cell: info => info.getValue().toFixed( 3 ),
      meta: {
        classStr: buildColumnClassString( { width: 15 } )
      }
    } ),
    columnHelper.accessor( 'professionalism', {
      header: 'Professional Score',
      size: 150,
      cell: info => info.getValue().toFixed( 3 ),
      meta: {
        classStr: buildColumnClassString( { width: 15 } )
      }
    } ),
    columnHelper.accessor( 'judgemental', {
      header: 'Judgemental Score',
      size: 150,
      cell: info => info.getValue().toFixed( 3 ),
      meta: {
        classStr: buildColumnClassString( { width: 15 } )
      }
    } ),
    columnHelper.accessor( 'mlflowUrl', {
      header: '',
      size: 200,
      cell: info => (
        <a href={ info.getValue() } target="_blank" rel="noopener noreferrer">
          View in MlFlow
        </a>
      ),
      meta: {
        classStr: buildColumnClassString( { width: 20 } )
      }
    } )
  ], [] );

  const table = useNativeTable( {
    data: performanceData,
    columns,
    enableSorting: false
  } );

  return <NativeTable table={ table } pagination="client" />;
}
